import * as idbKeyval from 'idb-keyval';
import { of } from 'rxjs';

import { usingInternetExplorer } from '../browser-helpers/browser-helper';

export function idbGet<T>(tag: string): Promise<T> {
	if (usingInternetExplorer()) {
		try {
			return of(JSON.parse(localStorage.getItem(tag))).toPromise();
		} catch {
			return of(undefined).toPromise();
		}
	} else {
		return idbKeyval.get(tag);
	}
}

export function idbSet(tag: string, value): Promise<void> {
	if (usingInternetExplorer()) {
		localStorage.setItem(tag, JSON.stringify(value));
		return of(null).toPromise();
	} else {
		return idbKeyval.set(tag, value);
	}
}

export function idbDel(tag: string): Promise<void> {
	if (usingInternetExplorer()) {
		localStorage.removeItem(tag);
		return of(null).toPromise();
	} else {
		return idbKeyval.del(tag);
	}
}

export async function idbExists(tag: string): Promise<boolean> {
	if (usingInternetExplorer()) {
		return localStorage.getItem(tag) !== null;
	} else {
		return (await idbKeyval.keys()).find(key => key === tag) !== null;
	}
}
